import { render, staticRenderFns } from "./SA.vue?vue&type=template&id=322233b4&scoped=true&"
import script from "./SA.vue?vue&type=script&lang=js&"
export * from "./SA.vue?vue&type=script&lang=js&"
import style0 from "./SA.vue?vue&type=style&index=0&id=322233b4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322233b4",
  null
  
)

export default component.exports